import {
  PayloadAction,
  createSlice
} from '@reduxjs/toolkit';

export type ActiveTool = 'feature-info' | 'layer-tree' | null;

const initialState: ActiveTool = 'layer-tree'; // null for no initial tool

export const slice = createSlice({
  name: 'activeTool',
  initialState: initialState as ActiveTool,
  reducers: {
    setActiveTool: (state: ActiveTool, action: PayloadAction<ActiveTool>) => {
      return action.payload;
    }
  }
});

export const {
  setActiveTool
} = slice.actions;

export default slice.reducer;
